const courseSettings = {
  language: "en",
  name: "Concepts of Programming Languages",
  siteUrl: "https://bryancsouza.github.io/COPL-26/",
  githubUrl: "https://github.com/bryancsouza/COPL-26",
  subtitle: "Object Oriented Programming",
  slug: "programming-23",
  organizationName: "Radboud University",
  tmcCourse: "radbouduniversiteit-COPL-oop-26",
  quizzesId: "5ffc21a8-5f0d-4c11-871d-ba5fa17b2bc0",
  tmcOrganization: "radbouduniversiteit",
  bannerPath: "banner.svg",
  showExerciseDescriptionWhenNotLoggedIn: true,
  courseVariants: [
    {
      tmcOrganization: "laurea",
      tmcCourse: "LaureA9288-3007_PrgrBasK2024_Python_kkah",
    },
    {
      tmcOrganization: "laurea",
      tmcCourse: "LaureA9288-3008_PrgrBasK2024_Python_kkah",
    },
  ],
}

module.exports = courseSettings
